import { FinanceiroObrasScreen } from "@/screens/financeiro/obras";

/** Thin wrapper — toda lógica fica em screens/financeiro/obras */
export function FinanceiroObrasPage() {
  return <FinanceiroObrasScreen />;
}
